import React from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { BarChart } from '../../../../../../components/singleComponents/dashboards/BarChart';
import { LineChart } from '../../../../../../components/singleComponents/dashboards/LineChart';
import { PieChart } from '../../../../../../components/singleComponents/dashboards/PieChart';

import { MOCK_DASHBOARD } from '../../../../../../../services/driverJS/mocks';

import {
  BarChartStyled,
  ButtonGroupStyled,
  DataContainerStyled,
  MonthsBtnStyled,
  PieChartStyled,
  SchedulesChartStyled,
  SchedulesHeaderStyled,
  SchedulesTitleStyled,
  StatusSymbolStyled,
  TitleContainerStyled,
  YearOptionStyled,
  YearsSelectStyled,
} from './index.styles';

export function TourDashboard() {
  const getStatusColor = (status) => {
    if (status === 'Concluído') return '#2ed059';
    if (status === 'Em andamento') return '#e9ad5c';
    return '#373737';
  };

  return (
    <>
      <TitleContainerStyled container justifyContent="space-between">
        <Grid item alignSelf="center">
          <Typography variant="h2" component="h2">
            Obra Tour
          </Typography>
        </Grid>
      </TitleContainerStyled>

      <DataContainerStyled container>
        <Grid item container alignItems="center" sx={{ mb: 5 }}>
          <Grid item>
            <ButtonGroupStyled
              variant="contained"
              aria-label="Basic button group"
            >
              <MonthsBtnStyled>12 meses</MonthsBtnStyled>
            </ButtonGroupStyled>
          </Grid>
          <Grid item sx={{ ml: 4 }}>
            <Grid container alignItems="center">
              <Grid item>
                <Typography component="h4" variant="h3">
                  Ano:
                </Typography>
              </Grid>
              <Grid item>
                <YearsSelectStyled value={0}>
                  <YearOptionStyled value={0}>Todos</YearOptionStyled>
                  {[2022, 2023, 2024].map((year, index) => (
                    <YearOptionStyled key={year} value={index + 1}>
                      {year}
                    </YearOptionStyled>
                  ))}
                </YearsSelectStyled>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container spacing={2} justifyContent="space-between">
          <Grid item sx={{ width: '60%' }}>
            <BarChartStyled>
              <LineChart
                data={MOCK_DASHBOARD.barChartData}
                selectedYear={0}
                title="Acumulado"
              />
            </BarChartStyled>
            <BarChartStyled>
              <BarChart
                data={MOCK_DASHBOARD.barChartData}
                selectedYear={0}
                title="Lançamentos"
              />
            </BarChartStyled>
          </Grid>

          <Grid item sx={{ width: '40%' }}>
            <PieChartStyled>
              <PieChart data={MOCK_DASHBOARD.pieChartData} />
            </PieChartStyled>
            <SchedulesChartStyled>
              <SchedulesTitleStyled component="h4" variant="h3">
                Evolução da obra/cronograma
              </SchedulesTitleStyled>
              <SchedulesHeaderStyled container>
                <Grid item sx={{ width: '60%' }}>
                  <Typography sx={{ fontWeight: 600 }}>Etapa</Typography>
                </Grid>
                <Grid item>
                  <Typography sx={{ fontWeight: 600 }}>Status</Typography>
                </Grid>
              </SchedulesHeaderStyled>
              {MOCK_DASHBOARD.schedules.map(({ description, status }) => (
                <SchedulesHeaderStyled container>
                  <Grid item sx={{ width: '60%' }}>
                    <Typography>{description}</Typography>
                  </Grid>
                  <Grid item>
                    <Grid container>
                      <Grid item>
                        <StatusSymbolStyled
                          sx={{ backgroundColor: getStatusColor(status) }}
                        />
                      </Grid>
                      <Grid item>
                        <Typography component="span">{status}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </SchedulesHeaderStyled>
              ))}
            </SchedulesChartStyled>
          </Grid>
        </Grid>
      </DataContainerStyled>
    </>
  );
}
